<template>
  <div class="mb-4">

    <!--#region -- Content ---->
    <!--#region SFDC Synchronization Real Data-->
    <div class="caption-label-hide d-flex" style="margin-left: -17px;">
      <div class="caption-label">
        <b-badge style="margin-right: 10px;" v-if="sfdcEngineeringServices" variant="primary">{{sfdcEngineeringServices.length}}</b-badge>
        <b-badge style="margin-right: 10px;" v-else variant="primary">0</b-badge>
        Engineering Service
        <b-button v-if="sfdcEngineeringServices != null && _.size(sfdcEngineeringServices) > 0"
                  v-b-toggle.collapseDemoLoans
                  variant="outline-primary"
                  class="text-primary text-left"
                  style="background-color: white; border: none; padding-left: 39px;">
          <b-icon :icon="isCollapsedES ? 'chevron-down' : 'chevron-up'"></b-icon>
        </b-button>
        <div v-if="opportunityId !== null && opportunityId !== ''">
          <a class="btn btn-primary" target="_blank" style="margin-left:10px"
             :href="safeUrl(`${ $root.frontEndUrl }/engineering-service/new/${opportunityId}`)">New</a>
        </div>
        <div v-else>
          <a class="btn btn-primary" target="_blank" style="margin-left:10px"
             :href="safeUrl(`${ $root.frontEndUrl }/engineering-service/new`)">New</a>
        </div>
        <!--
      <div>
    <b-alert v-if="!sfdc_demo_loans_loading" show dismissible variant="primary">
      Click to expand the <b>Salesforce Demo Loans </b>details.
    </b-alert>
  </div>
    -->
      </div>
    </div>

    <b-collapse id="collapseDemoLoans" visible @shown="onShownES" @hidden="onHiddenES" accordion="Salesforce Demo Loans" role="tabpanel">

      <div style="padding-top: 10px;" v-if="sfdcEngineeringServices != null && _.size(sfdcEngineeringServices) > 0">
        <b-table :fields="sfdcEsFields" :items="sfdcEngineeringServices"
                 small
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 style="width: calc(100% - 10px)">
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #cell(NAME)="data">
            <a class="link" target="_blank" :href="safeUrl(`${ frontEndUrlToUse }engineering-service/opty-id/${ data.item.ID }`)">
              {{data.item.NAME}}
            </a>

          </template>
          <template #cell(FTIE_ID__C)="data">
            <a class="link" target="_blank" :href="safeUrl(`${ frontEndUrlToUse }ftie/ftie-page/${ data.item.FTIE_ID__C }`)">
              {{data.item.FTIE_ID__C}}
            </a>
          </template>

        </b-table>
      </div>
    </b-collapse>

    <!--#endregion-->
    <!-- #endregion Modal-->
  </div>
</template>

<script>
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'sfdc-engineering-services',
    props: {
      prop_sfdc_es: {
        default: null
      },
      prop_user_sites: {
        default: null
      },
      prop_user: {
        default: null
      },
      prop_opp_id: {
        default: null
      },

    },
    data: function () {
      return {
        isRouterAlive: true,
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        sfdcEngineeringServices: null,
        sfdcEngineeringServicesOriginal: null,
        fixModel: true,
        fixCustomizationPn: "Customization",
        basicInfo: null,
        loginUser: null,
        userSites: null,
        actionEnable: false,
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        createBy: null,
        searching: false,
        noneSelectedHint: '',
        sfdcEsFields: [
          { key: 'NAME', label: 'Service ID', thClass: 'align-middle', sortable: true },
          { key: 'FTIE_ID__C', label: 'FTIE ID', thClass: 'align-middle', sortable: true },
          { key: 'ACCOUNT_NAME', label: 'Account', thClass: 'align-middle', sortable: true },
          { key: 'OPPORTUNITY_NAME', label: 'Opportunity', thClass: 'align-middle', sortable: true },
          { key: 'MODEL_NAME', label: 'Product', thClass: 'align-middle', sortable: true },
          { key: 'ES_CREATEDDATE', label: 'Create Date', thClass: 'align-middle', sortable: true },
          { key: 'OWNER_NAME', label: 'Owner', thClass: 'align-middle', sortable: true },
        ],
        reloadBusy: false,
        isCollapsedES: false,
      }
    },
    computed: {
      userFunctions() {
        return this.$session.get('user_functions');
      },
      userRoles() {
        return this.$session.get('user_roles');
      },

    },
    created() {
      let self = this;
      self.sfdcEngineeringServices = self.prop_sfdc_es; // prop_sfdc_demo_loans;
      self.sfdcEngineeringServicesOriginal = self.prop_sfdc_es;
      self.userSites = self.prop_user_sites;
      self.loginUser = self.prop_user;
      self.opportunityId = self.prop_opp_id;
      self.actionEnable = self.checkActionEnable();
      // console.log("SFDC Copo actionEnable:");
      // console.log(self.actionEnable);
    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },
      onShownES() {
        this.isCollapsedES = false;
      },
      onHiddenES() {
        this.isCollapsedES = true;
      },

      checkActionEnable() {
        let self = this;
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        if (self.loginUser === 'power') {
          return true;
        }

        // loginUser is gtc owner
        if (self.loginUser !== null && self.createBy !== null && self.loginUser === self.createBy) {
          return true;
        }
        if (self.userRoles !== null && _.size(self.userRoles) > 0) {
          if (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 || _.indexOf(self.userRoles, 'Admin') > -1 || _.indexOf(self.userRoles, 'ES_PM') > -1) {
            return true;
          }
        }
        if (self.userFunctions !== null && _.size(self.userFunctions) > 0) {
          if (_.indexOf(self.userFunctions, 'ES PM Leader') > -1 || _.indexOf(self.userFunctions, 'Tech Leader') > -1) {
            return true;
          }
        }
        //login_user_name === ftie_page_obj.gtc_owner || login_user_name === 'power' || (userRoles !== null && userRoles.includes('Admin')))
        return false;
      },

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/framework-sfdc/SfdcEngineeringServices.vue